module.exports = __webpack_public_path__ + "img/icon-swap-enable.39784740.svg";